const messages = {
  bonus: {
    title: "Přehled bonusových kreditů",
    description: "Bonusy v eurech jsou přidělovány zúčastněným společnostem na základě nahlášených prodejních údajů.",
    lastMonth: "Minulý měsíc",
    currentMonth: "Aktuální měsíc",
    totalCurrentYear: "Celkem za aktuální rok",
    totalLastYear: "Celkem za minulý rok",
  },
  points: {
    title: "Přehled bodových kreditů",
    period: "Probíhající kalendářní rok ({year})",
    totalAwarded: "Celkem přidělených bodů",
    redeemed: "Využité body",
    totalBalance: "Celkový stav bodů",
    redemptionRate: "Uplatněné body jako procento přidělených bodů",
    averageAwarded: "Průměr přidělených bodů na zakoupenou pneumatiku",
    standardAwarded: "Čisté body z vypočtených prodejních řádků, včetně vratek",
    bsPlusInclBooster: "Body z prodejních řádků s kladným množstvím",
    perTire: "Uplatněné body na zakoupenou pneumatiku",
  },
  tires: {
    title: "Přehled množství pneumatik",
    description: "Pneumatiky nakoupené zákazníky",
    prevMonth: "Předchozí měsíc",
    totalLastYear: "Celkem za minulý rok",
    purchaseIndirect: "Nákup přes velkoobchod (nepřímo)",
    purchaseDirect: "Nákup přes velkoobchod (přímo)",
    totalCurrentYear: "Celkem za aktuální rok",
    currentMonth: "Aktuální měsíc",
  },
  participating: {
    title: "Přehled zapojených zákazníků",
    description: "Společnosti, které se zaregistrují do BRIDGESTONE PLUS, mohou být přiřazeny pomocí zákaznického čísla.",
    total: "Celkem",
    newThisMonth: "Nové tento měsíc",
    newThisYear: "Nové tento rok",
    createdInCurrentMonth: "Vytvořeno v aktuálním měsíci (správcem)",
    loginsCurrentYear: "Přihlášení v aktuálním roce (po přijetí podmínek)",
  },
  brand: {
    title: "Značka",
    description: "Vaše nákupy v detailu",
    centerTitle: "Podle\nznačky",
  },
  rim: {
    title: "Ráfek",
    centerTitle: "Podle velikosti\nráfku",
  },
  tireGoals: {
    title: "Cíle plnění pneumatik",
    subtitle: "Získejte body za nákupy pneumatik.",
    centerTitle: "Podle\nrozměru pneumatiky",
    tiresRemaining: "Zbývající pneumatiky",
    progressionTarget: "Cíl postupu: ",
    pointsEarnedPurchases: "body získané\n" + "vašimi\n" + "nákupy",
    pointsEarnedBoosters: "body získané\n" + "pomocí\n" + "boosterů",
    purchasesDetail: "Vaše nákupy v detailu",
    cta: "Zjistěte více o svých bodech",
    pointsTitle: "Vaše body",
    pointsSubtitle: "Body získané za nákupy Bridgestone",
    achievementsTitle: "Vaše výsledky",
    achievementsSubtitle: "Váš roční závazek:",
    achievementsSubtitle2: "pneumatik",
  },
  score: {
    title: "Skóre",
    total: "Celkem",
    credits: "Kredity v",
    deductions: "Odečty v",
        unlockedPoints: "Odemčené body",
        pendingPoints: "Čekající body",
  },
  score_extended: {
    title1: "Bodový zůstatek",
    title2: "Bonus v eurech",
    balance: "Bodový zůstatek",
    bonus_in_euro: "Bonus v eurech",
    date: "Datum",
    added_points: "Body přidané v",
    total_bands: "Celkem značek",
    goal: "Cíl",
    tyres_previous_year: "Pneumatiky prodané loni",
    tyres_current_year: "Pneumatiky prodané letos",
    target_this_year: "Prodejní cíl pro tento rok",
    bonus_this_year: "Získaný bonus (€)",
    loyal_minimum: "Minimální úroveň loajality",
    bonus_multiplier: "Sazba bonusového násobku",
  },
  lastImport: {
    label: "Poslední import prodejních údajů:",
    on: "dne",
  },
  wholesalerTable: {
    title: "Zapojení zákazníci v detailu",
    description: "Níže najdete společnosti, které se zaregistrovaly do BRIDGESTONE PLUS se zákaznickým číslem vaší společnosti. Můžete použít filtry pro jiné řazení nebo vyhledávání pro dohledání zákazníků.",
    columns: {
      customer_number: "Zák. číslo",
      address_company_name: "Společnost",
      address_street: "Ulice a číslo",
      address_postal_code: "PSČ",
      address_city: "Město",
      last_registration: "Poslední registrace",
      network: "Síť",
      profile_group: "Skupina",
      tires_amount: "Počet pneumatik",
      point_balance: "Bodový zůstatek",
      bonus: "Bonus",
      details: "Detail",
    },
    searchPlaceholder: "Hledat",
  },
  dealerTable: {
    columns: {
      date: "Datum",
      wholesaler_bs_plus: "Velkoobchod BS+",
      customer_number: "Zákaznické číslo",
      article: "Položka",
      brand: "Značka",
      product: "Produkt",
      type: "Typ",
      inch: "Palec",
      season: "Sezóna",
      amount: "Množství",
      points: "Body",
      activity: "Aktivita",
      total_points: "Celkem bodů",
    },
    title: "Tabulka dealerů",
    description: "Přehled aktivit dealerů",
  },
  business_units: {
    title: "Obchodní jednotky",
    centerTitle: "Podle\njednotky",
  },
  season: {
    title: "Sezóna",
    centerTitle: "Podle období\nroku",
  },
};

export default {
  messages,
};
